const round = (amount) => Math.round((amount + Number.EPSILON) * 100) / 100;

export function splitOrderTaxes(summary) {
  const fees = summary?.fees || [];
  const service = fees.find((fee) => ["Service Fees", "Bizzll Fee"].includes(fee.label));
  const businessFees = fees.filter((fee) => ["Business Tax", "Convention and Tourism Tax"].includes(fee.label));
  const base = summary?.subtotal == null ? null : Number(summary.subtotal) + Number(summary.delivery || 0);
  const bizzllFee = service ? Number(service.amount) : base === null ? null : round(base * 0.1);
  const totalTax = businessFees.length === 2
    ? round(businessFees.reduce((sum, fee) => sum + Number(fee.amount), 0))
    : summary?.rate != null && base !== null
      ? round(base * Math.max(0, summary.rate - 10) / 100)
      : null;
  return { totalTax, bizzllFee };
}
